<template>
  <div class="calendar-container noselect" v-if="!showBookingPickerFor">
    <div
      v-if="showOverlay"
      class="calendar-overlay"
    >
      <v-container fill-height>
        <v-layout class="align-center">
          <v-flex xs12>
            <input
              type="button"
              :value="$t('check_availability')"
              :class="'input_full filter-submit ' + (mobile ? 'mobile-button' : '')"
              @click.prevent="navigateToObjectBookingForm(selectedObject)"
            >
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div v-if="plusMonths" class="calendar-nav">
      <b>{{ monthName }} {{ yearNumber }}</b>
    </div>
    <div v-else class="calendar-nav noselect">
      <v-icon
        small
        @click="prevMonth()"
        style="padding-right: 7px; padding-top: 5px;"
      >
        fa-chevron-circle-left
      </v-icon>
			<select
        v-model="calendarMonth"
        class="calendar-nav-select-month"
        id="calendar-nav-month"
        name="calendar_month"
      >
        <option
          v-for="(month, index) in months"
          :key="index"
          :value="month.number"
        >
          {{ month.name }}
        </option>
        </select>
        <select
          v-model="calendarYear"
          class="calendar-nav-select-year"
          id="calendar-nav-year"
          name="calendar_year"
        >
          <option
            v-for="(year, index) in years"
            :key="index"
            :value="year"
          >
            {{ year }}
          </option>
        </select>
        <v-icon
          small
          @click="nextMonth()"
          style="padding-left: 7px; padding-top: 5px;"
        >
          fa-chevron-circle-right
        </v-icon>
      </div>
      <div id="calendar-container">
        <table class="calendar"
          :style="mobile ? 'width: 100%;' : ''"
        >
        <colgroup>
          <col class="esmaspäev">
          <col class="teisipäev">
          <col class="kolmapäev">
          <col class="neljapäev">
          <col class="reede">
          <col class="laupäev">
          <col class="pühapäev">
        </colgroup>
        <thead>
            <tr>
              <th
                v-for="(nullval, index) in [...Array(7)]"
                :key="index"
                :title="index"
              >
                {{ weekDayLetter(index) }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="week in Object.keys(monthWeekDays)"
              :key="week"
            >
              <!-- td class="pad">{{ week }}</td -->
              <td
                v-for="dayOfWeek in Object.keys(monthWeekDays[week])"
                :key="dayOfWeek"
                :class="dayClass(monthWeekDays[week][dayOfWeek])"
                :title="monthWeekDays[week][dayOfWeek].dayText"
                v-html="dayValue(monthWeekDays[week][dayOfWeek])"
                @click="selectDateFromNavigationCalendar(monthWeekDays[week][dayOfWeek])"
              >
            </td>
            <!-- td
              v-for="dayOfWeek in Object.keys(monthWeekDays[week])"
              :key="dayOfWeek + '_z'"
              :class="dayClass(monthWeekDays[week][dayOfWeek])"
              v-html="monthWeekDays[week][dayOfWeek].dayDate"
             -->
          </td>
          </tr>
          </tbody>
        </table>
    </div>
  </div>
</template>

<script>
import helper from './../helper'
import Vue from 'vue'
import sharedMethods from './../methods/sharedMethods'
import moment from 'moment'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'CalendarNavigation',

  data: () => {
    return {
      firstWeekNumber: null,
      lastWeekNumber: null,
      firstDay: null
    }
  },

  props: {
    plusMonths: {
      type: Number,
      default: 0
    },
    showOverlay: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapFields(Object.keys(state)),

    computedMonth () {
      return moment(this.calendarYear + '-' + this.calendarMonth + '-01').add(this.plusMonths, 'month').format('MM')
    },

    computedYear () {
      return moment(this.calendarYear + '-' + this.calendarMonth + '-01').add(this.plusMonths, 'month').format('YYYY')
    },

    monthName () {
      moment.locale(this.lang)
      return moment(this.computedYear + '-' + this.computedMonth + '-01').format('MMMM')
    },

    yearNumber () {
      moment.locale(this.lang)
      return moment(this.computedYear + '-' + this.computedMonth + '-01').format('YYYY')
    },

    monthWeekDays () {
      moment.locale(this.lang)
      let firstWeekMonday = moment(this.firstDay).startOf('isoWeek').format('YYYY-MM-DD')
      let selectedMonthFirstDay = moment(this.computedYear + '-' + this.computedMonth + '-01')
      let selectedMonthNumber = selectedMonthFirstDay.format('M')

      const maxWeeks = 6
      let monthWeekDays = {}
      let monday = moment(firstWeekMonday)
      for (let j = 0; j <= maxWeeks; j++) {
        let sunday = moment(monday.format('YYYY-MM-DD')).add(6, 'days')
        let weekDays = {}

        // console.log('j', j, monday, monday.format('MM'), this.computedMonth)

        // monday or sunday is within month
        if (monday.format('MM') === this.computedMonth || sunday.format('MM') === this.computedMonth) {
          for (let dayOfWeek = 0; dayOfWeek <= 6; dayOfWeek++) {
            let day = moment(monday.format('YYYY-MM-DD')).add(dayOfWeek, 'days')
            const isSelected = day.format('DD.MM.YYYY') === this.searchFilters.dateStart ||
              (this.searchFilters.dateStart && this.searchFilters.dateEnd &&
                day >= moment(helper.dateToYMD(this.searchFilters.dateStart)) &&
                day <= moment(helper.dateToYMD(this.searchFilters.dateEnd))
              )
            weekDays[dayOfWeek] = {
              day: day,
              isSelected: isSelected,
              dayDate: day.format('YYYY-MM-DD'),
              dayOfWeek: dayOfWeek,
              dayText: day.format('LL'),
              dayNumber: day.format('DD'),
              sameMonth: day.format('M') === selectedMonthNumber,
              passed: day.isBefore(moment().startOf('day').format()),
              today: day.format('DD-MM-YYYY') === moment().format('DD-MM-YYYY')
            }
          }
        }
        if (Object.keys(weekDays).length > 0) {
          monthWeekDays[j] = weekDays
        }
        monday = moment(sunday.format('YYYY-MM-DD')).add(1, 'day')
      }
      return monthWeekDays
    },

    years () {
      return [
        moment().format('Y'),
        parseInt(moment().format('Y')) + 1,
        parseInt(moment().format('Y')) + 2
      ]
    },

    months () {
      moment.locale(this.lang)
      let months = []
      for (let i = 1; i <= 12; i++) {
        let monthNumber = i.toString().length === 1 ? '0' + i.toString() : i.toString()
        months.push({
          number: moment('2000-' + monthNumber + '-01').format('MM'),
          name: moment('2000-' + monthNumber + '-01').format('MMMM')
        })
      }
      return months
    }
  },

  watch: {
    calendarYear (value, before) {
      const month = moment(this.calendarYear + '-' + this.calendarMonth + '-01')
      if (this.isMonthInTheFuture(month)) {
        this.updateWeekNumbers()
      } else {
        this.calendarYear = before
      }
    },

    calendarMonth (value, before) {
      const month = moment(this.calendarYear + '-' + this.calendarMonth + '-01')
      if (this.isMonthInTheFuture(month)) {
        this.updateWeekNumbers()
      } else {
        this.calendarMonth = before
      }
    },

    lang (value) {
      moment.locale(value)
    }
  },

  created () {
    moment.locale(this.$route.params && this.$route.params.lang || 'en')
    this.updateWeekNumbers()
  },

  methods: {
    ...sharedMethods,

    isMonthInTheFuture (month) {
      return month.format('YYYYMM') >= moment().format('YYYYMM')
    },

    selectDateFromNavigationCalendar (day) {
      if (day.day.format('YYYYMMDD') < moment().format('YYYYMMDD')) { return }
      const date = day.dayDate
      if (this.$route.name === 'calendar') { return }
      if (!this.searchFilters.dateStart || this.searchFilters.dateEnd) {
        // Set date start
        const canBookThatDate = !this.selectedObject || !this.selectedObject.bookedDays ||
          !this.selectedObject.bookedDays[date]
        if (canBookThatDate) {
          Vue.set(this.searchFilters, 'dateStart', moment(date).format('DD.MM.YYYY'))
          Vue.set(this.searchFilters, 'dateEnd', null)
        }
      } else if (moment(date) > moment(helper.dateToYMD(this.searchFilters.dateStart))) {
        const prevDate = moment(date).subtract(1, 'day').format('YYYY-MM-DD')
        const canBookThatDate = !this.selectedObject || !this.selectedObject.bookedDays ||
          !this.selectedObject.bookedDays[prevDate]
        if (!this.checkIfPeriodCanBeBooked(date)) {
          Vue.set(this.searchFilters, 'dateStart', null)
          Vue.set(this.searchFilters, 'dateEnd', null)
        } else if (canBookThatDate) {
          Vue.set(this.searchFilters, 'dateEnd', moment(date).format('DD.MM.YYYY'))
        }
      }
    },

    checkIfPeriodCanBeBooked (endDate) {
      var day = moment(helper.dateToYMD(this.searchFilters.dateStart))
      while (day.format('YYYYMMDD') < moment(endDate).subtract(1, 'day').format('YYYYMMDD')) {
        day = day.add(1, 'day')
        const canBookThatDate = !this.selectedObject || !this.selectedObject.bookedDays ||
          !this.selectedObject.bookedDays[day.format('YYYY-MM-DD')]
        if (!canBookThatDate) {
          return false
        }
      }
      return true
    },

    nextMonth () {
      let nextMonth = moment(this.calendarYear + '-' + this.calendarMonth + '-01').add(1, 'month')
      if (parseInt(nextMonth.format('YYYY')) <= parseInt(moment().format('YYYY')) + 2) {
        this.calendarYear = nextMonth.format('YYYY')
        this.calendarMonth = nextMonth.format('MM')
      }
    },

    prevMonth () {
      let prevMonth = moment(this.calendarYear + '-' + this.calendarMonth + '-01').subtract(1, 'month')
      if (this.isMonthInTheFuture(prevMonth)) {
        this.calendarYear = prevMonth.format('YYYY')
        this.calendarMonth = prevMonth.format('MM')
      }
    },

    dayValue (day) {
      if (!day.sameMonth) {
        return '&nbsp;'
      }
      return day.dayNumber
    },

    dayClass (day) {
      let classes = []
      if (!day || !day.sameMonth) {
        return 'pad'
      }
      if (day.isSelected) {
        classes.push('selected-day')
      }
      if (day.today) {
        classes.push('today')
      }
      if (day.passed) {
        classes.push('passed')
      }
      // booked....
      let bookedStatus = this.dayIsBooked(day.dayDate)
      let previousDay = moment(day.dayDate).subtract(1, 'day').format('YYYY-MM-DD')
      let previousDayStatus = this.dayIsBooked(previousDay)
      if (['confirmed', 'archived', 'owner'].includes(bookedStatus)) {
        if (!previousDayStatus) {
          classes.push('pm_booked')
        } else {
          classes.push('booked')
        }
      } else if (bookedStatus === 'new') {
        if (!previousDayStatus) {
          classes.push('pm_onhold')
        } else {
          classes.push('onhold')
        }
      } else {
        // Check if previous day was booked
        if (['confirmed', 'archived', 'owner'].includes(previousDayStatus)) {
          classes.push('am_booked')
        } else if (['new'].includes(previousDayStatus)) {
          classes.push('am_onhold')
        }
      }
      // console.log('_', day.dayDate, classes, day.isSelected)
      return classes.join(' ')
    },

    dayIsBooked (date) {
      if (this.selectedObject && this.selectedObject.bookedDays) {
        if (this.selectedObject.bookedDays[date]) {
          return this.bookingStatuses[this.selectedObject.bookedDays[date]]
        }
      }
      return false
    },

    weekDayLetter (index) {
      return moment().startOf('isoWeek').add(index, 'days').format('dd')
    },

    updateWeekNumbers () {
      this.firstDay = this.computedYear + '-' + this.computedMonth + '-01'
      this.firstWeekNumber = moment(this.computedYear + '-' + this.computedMonth + '-01')
        .format('w')
      this.lastWeekNumber = moment(this.firstDay).endOf('month').format('w')
    }
  }
}
</script>

<style>
.calendar-container {
  margin-top: 12px;
  margin-bottom: 8px;
  position: relative;
}
.calendar-overlay {
  background: rgba(255, 255, 255, 0.75);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
}
#calendar-nav-prev {
  margin-right: 4px !important;
}
#calendar-nav-next {
  margin-left: 4px !important;
}
#calendar-nav-month {
  margin-right: 2px !important;
}
</style>
